import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Header from './components/Header';
import Pricing from './pages/Pricing';
import AboutUs from './pages/AboutUs';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import Footer from './components/Footer';
import HomeMain from './pages/HomeMain';
import Contact from './pages/Contact';
import { useEffect } from 'react';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  // const navigate = useNavigate()
  
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'; // Prevent auto-restoration of scroll
    }
    window.scrollTo(0, 0); // Set scroll position to the top immediately
  }, [pathname]);

  return null;
};
function App() {
  return (
    <>
      <Router>
        <ScrollToTop/>
        <Header/>
            <Routes>
                <Route path="/" element={<HomeMain />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/termsandconditions" element={<TermsAndConditions />} />
                <Route path="/privacyandpolicy" element={<PrivacyPolicy />} />
                <Route path="/refundpolicy" element={<RefundPolicy />} />
            </Routes>
        <Footer/>
      </Router>
    </>
  );
}

export default App;
